import Content from '../../content.js';
import DataTables from '../../components/dataTables';

namespace('IO.Views.PaymentDevices', function (exports) {
  'use strict';

  var Index = Content.extend({
    dom: {
      DATATABLES: '.dataTables',
      ONE_SELECTION_ACTION: '.dropdown-toggleable-option-one',
      PAYMENT_DEVICES_BULK: '#payment_devices_bulk',
      PAYMENT_DEVICE_IDS: '#payment_device_ids',
    },

    SERIAL_ID_COL: 6,
    QUERYABLE_TYPE_COL: 10,

    onDestroy: function () {
      this.dataTable.remove();
      this.bulkActions.detach();
      if (this.serialRetrieval) {
        this.serialRetrieval.detach();
      }
    },

    render: function () {
      var self = this,
        $table = this.$(this.dom.DATATABLES),
        bulkActionsArguments,
        dataTableOpts;

      if (window.isEstateManagement === true) {
        window.paymentDeviceColumns[0].sTitle =
          '<form class="custom" ' +
          'style="position: relative; right: -3px; top: -1px">' +
          '<input id="select-all" type="checkbox" /></form>';
      }

      dataTableOpts = {
        ajaxSource:
          '/' +
          currentCustomer +
          '/stores/' +
          $table.data('store') +
          '/payment_devices.json',
        controller: 'stores/' + $table.data('store') + '/payment_devices',
        columns: window.paymentDeviceColumns,
        el: $table,
        filter: true,
        fixed: false,
        title: 'Click to edit',
        sorting: [[0, 'asc']],
        oLanguage: {
          sZeroRecords: 'No payment devices created yet.',
        },
      };

      if (window.isEstateManagement === true) {
        dataTableOpts.aoColumnDefs = [
          {
            aTargets: [0],
            mRender: function (data, type, full) {
              return (
                "<form class='custom checkbox'><input type='checkbox' name='rule-checkbox' data-name='" +
                full[2] +
                "' data-attr='" +
                JSON.stringify(full) +
                "' class='row-checkbox'" +
                "value='" +
                _.last(full) +
                "'  /></form>"
              );
            },
          },
        ];
        if (showPaymentDeviceInfoRetrievalLogs) {
          dataTableOpts.aoColumnDefs.push({
            aTargets: [6],
            mRender: function (data, type, full) {
              var url =
                location.href.split('#')[0] +
                '/payment_devices/' +
                _.last(full) +
                '/history';

              return (
                '<a title="Click for details" href="' +
                url +
                '">' +
                full[6] +
                '</a>'
              );
            },
          });
        }

        dataTableOpts.aoColumnDefs.push({
          targets: 0,
          orderable: false,
        });

        dataTableOpts.sorting = [[2, 'asc']];
      }

      this.dataTable = new DataTables(dataTableOpts);
      this.dataTable.start();

      bulkActionsArguments = {
        controller: '/payment_devices',
        actions: {
          move: {
            text: 'Move to Store',
            disabledMessage:
              'Payment Devices without a serial number can not be moved between Stores.',
            conditionCheck: function (items) {
              var enabled = true;

              items.forEach(function (item) {
                if (item[self.SERIAL_ID_COL] == 'None') {
                  enabled = false;
                }
              });
              return enabled;
            },
          },
        },
      };

      if (window.isPaymentDeviceInfoRetrieval) {
        this.serialRetrieval = new PaymentDeviceSerialRetrieval(this.$el);
        bulkActionsArguments.actions.query = {
          text: 'Retrieve Payment Device Information',
          disabledMessage:
            'Serial Retrieval is only supported for the following models: VX, MX and Engage.',
          callback: this.serialRetrieval.process.bind(this.serialRetrieval),
          conditionCheck: function (items) {
            var enabled = true;

            items.forEach(function (item) {
              if (item[self.QUERYABLE_TYPE_COL] == false) {
                enabled = false;
              }
            });
            return enabled;
          },
        };
      }

      this.bulkActions = new BulkActions(this.$el, bulkActionsArguments);
    },
  });

  exports.Index = Index;
});
